const messageTypes = {
  Success: "SUCCESS",
  Error: "ERROR",
  Warning: "WARNING",
  Info: "INFO",
};

export default messageTypes;
